import * as React from 'react';
import { Button } from '@/components/forms/ui/button';
import { cn } from '@/lib/utils';

type BooleanOption = {
  value: boolean;
  label: string;
  description?: React.ReactNode;
};

type BooleanSelectFieldProps = {
  value: boolean;
  options: ReadonlyArray<BooleanOption>;
  onChange: (value: boolean) => void;
  label?: React.ReactNode;
  disabled?: boolean;
  className?: string;
};

export function BooleanSelectField({
  value,
  options,
  onChange,
  label,
  disabled = false,
  className
}: BooleanSelectFieldProps) {
  const selectedDescription = options.find(opt => opt.value === value)?.description ?? null;
  return (
    <div className={cn('flex flex-col gap-1', className)}>
      {label ? <span className="text-sm font-medium">{label}</span> : null}
      <div className="flex flex-wrap gap-2">
        {options.map(opt => {
          const isActive = opt.value === value;
          return (
            <Button
              key={String(opt.value)}
              type="button"
              variant={isActive ? 'default' : 'outline'}
              onClick={() => onChange(opt.value)}
              aria-pressed={isActive}
              disabled={disabled}
              className={cn(
                'h-9 border px-2 font-light',
                isActive ? 'border-transparent' : 'border-input'
              )}>
              {opt.label}
            </Button>
          );
        })}
      </div>
      {selectedDescription}
    </div>
  );
}
